"use client";

import {
  DISCOVERY_COPY,
  formatNearYouSubtitle,
  type NearYouLocationContext,
} from "@/lib/discovery/copy";

type MarketPageHeaderProps = {
  /** Resolved area/state context; null falls back to the generic subtitle. */
  locationContext: NearYouLocationContext | null;
};

/**
 * Benefit-first market header: the single visible H1 for /market plus a
 * location-aware subtitle. Copy is owned by lib/discovery/copy.ts.
 */
export default function MarketPageHeader({
  locationContext,
}: MarketPageHeaderProps) {
  return (
    <header className="mb-6">
      <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
        {DISCOVERY_COPY.h1}
      </h1>
      <p className="mt-1 text-text-light">
        {formatNearYouSubtitle(locationContext)}
      </p>
    </header>
  );
}
